export default __webpack_public_path__ + "static/media/email.f6d9add5.svg";